var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortalConnectionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3dafe"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.333,
    x2: 463.196,
    xlinkHref: "#lg1",
    y1: 59.333,
    y2: 463.196
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.499,
    x2: 124.816,
    xlinkHref: "#lg1",
    y1: 389.501,
    y2: 124.819
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ac9fe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    stopColor: "#85c2f3",
    stopOpacity: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3677,
    stopColor: "#70a3c3",
    stopOpacity: 0.368
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6362,
    stopColor: "#608ca0",
    stopOpacity: 0.636
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8561,
    stopColor: "#577e8b",
    stopOpacity: 0.856
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#537983"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 98,
    y2: 46.649
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.323,
    x2: 425.056,
    xlinkHref: "#lg2",
    y1: 189.989,
    y2: 154.256
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.011,
    x2: 76.572,
    xlinkHref: "#lg2",
    y1: 184.323,
    y2: 145.884
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 409.333,
    y2: 445.333
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.677,
    x2: 78.319,
    xlinkHref: "#lg2",
    y1: 327.011,
    y2: 362.369
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 393.323,
    x2: 426.405,
    xlinkHref: "#lg2",
    y1: 324.011,
    y2: 357.093
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8ecfe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7867,
    stopColor: "#9bd1fe",
    stopOpacity: 0.787
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ac9fe"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 385,
    y2: 491.17
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 471.999,
    x2: 271.278,
    xlinkHref: "#lg2",
    y1: 472.001,
    y2: 271.28
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 37,
    x2: -6.687,
    xlinkHref: "#lg3",
    y1: 255,
    y2: 255
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(-1 0 0 1 1118 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 645,
    x2: 601.313,
    xlinkHref: "#lg3",
    y1: 255,
    y2: 255
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.872,
    x2: 120.872,
    xlinkHref: "#lg3",
    y1: 63.252,
    y2: 30.252
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 365.206,
    x2: 388.968,
    xlinkHref: "#lg3",
    y1: 64.015,
    y2: 22.583
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.694,
    x2: 339.092,
    y1: 148.054,
    y2: 336.452
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0d4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0593fc"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2e62e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#97de30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3395,
    stopColor: "#79cb36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6234,
    stopColor: "#4aab3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9609,
    stopColor: "#09804c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017b4e"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.569,
    x2: 418.336,
    xlinkHref: "#lg4",
    y1: 118.431,
    y2: 315.198
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.087,
    x2: 254.216,
    xlinkHref: "#lg4",
    y1: 259.384,
    y2: 384.513
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.183,
    x2: 367.832,
    xlinkHref: "#lg4",
    y1: 279.523,
    y2: 312.171
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.638,
    x2: 196.638,
    y1: 321.078,
    y2: 390.889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#017b4e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4693,
    stopColor: "#01764a",
    stopOpacity: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026841"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.42,
    x2: 300.655,
    y1: 281.688,
    y2: 402.864
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2740b0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3153,
    stopColor: "#243ba4",
    stopOpacity: 0.315
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8855,
    stopColor: "#1b2d84",
    stopOpacity: 0.886
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192a7d"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m480.754 184.814h-47.651c-7.004-17.76-16.596-34.213-28.298-48.913l23.854-41.317c8.076-13.988 3.283-31.875-10.705-39.951l-70.91-40.94c-13.988-8.076-31.875-3.283-39.951 10.705l-23.843 41.299c-9.22-1.364-18.651-2.08-28.25-2.08s-19.03.716-28.25 2.08l-23.844-41.299c-8.076-13.988-25.963-18.781-39.951-10.705l-70.91 40.94c-13.988 8.077-18.781 25.963-10.705 39.951l23.854 41.317c-11.702 14.699-21.294 31.153-28.298 48.913h-47.65c-16.152 0-29.246 13.094-29.246 29.246v81.88c0 16.152 13.094 29.246 29.246 29.246h47.65c7.004 17.76 16.596 34.213 28.298 48.913l-23.854 41.317c-8.076 13.988-3.283 31.875 10.705 39.951l70.91 40.94c13.988 8.076 31.875 3.283 39.951-10.705l23.844-41.299c9.22 1.364 18.651 2.08 28.25 2.08s19.03-.716 28.25-2.08l23.844 41.299c8.076 13.988 25.963 18.781 39.951 10.705l70.91-40.94c13.988-8.076 18.781-25.963 10.705-39.951l-23.854-41.317c11.702-14.699 21.294-31.153 28.298-48.913h47.65c16.152 0 29.246-13.094 29.246-29.246v-81.88c0-16.152-13.094-29.246-29.246-29.246z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.999,
    cy: 255.002,
    fill: "url(#SVGID_2_)",
    r: 169.635
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m283.25 65.697c-9.22-1.364-18.651-2.08-28.25-2.08s-19.03.716-28.25 2.08l28.25 48.931z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.805 135.901-28.24 48.912h56.538c-7.004-17.759-16.596-34.212-28.298-48.912z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.195 135.901c-11.702 14.699-21.294 31.153-28.298 48.913h56.538z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.75 444.303c9.22 1.364 18.651 2.08 28.25 2.08s19.03-.716 28.25-2.08l-28.25-48.931z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.434 325.186h-56.537c7.004 17.76 16.596 34.213 28.298 48.913z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.805 374.099c11.702-14.699 21.294-31.153 28.298-48.912h-56.538z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m89.408 351c4.705 8.094 9.986 15.812 15.786 23.099l-23.854 41.317c-8.076 13.988-3.283 31.875 10.705 39.951l70.91 40.94c13.988 8.076 31.875 3.283 39.951-10.705l23.844-41.299c9.22 1.364 18.651 2.08 28.25 2.08s19.03-.716 28.25-2.08l23.844 41.299c8.076 13.988 25.963 18.781 39.951 10.705l70.91-40.94c13.988-8.076 18.781-25.963 10.705-39.951l-23.854-41.317c5.801-7.286 11.081-15.005 15.786-23.099z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.754 325.186c15.451 0 28.095-11.985 29.164-27.164l-143.042-143.041c-27.433-30.092-66.949-48.977-110.877-48.977-82.842 0-149.998 67.156-149.998 149.998 0 43.928 18.885 83.444 48.977 110.877l78.27 78.27c7.139.81 14.396 1.234 21.752 1.234 9.599 0 19.03-.716 28.25-2.08l23.844 41.299c8.076 13.988 25.963 18.781 39.951 10.705l70.91-40.94c13.988-8.076 18.781-25.963 10.705-39.951l-23.854-41.317c11.702-14.699 21.294-31.153 28.298-48.913z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 184.814h-24.754c-16.152 0-29.246 13.094-29.246 29.246v81.88c0 16.152 13.094 29.246 29.246 29.246h24.754z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456 184.814h24.754c16.152 0 29.246 13.094 29.246 29.246v81.88c0 16.152-13.094 29.246-29.246 29.246h-24.754z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m104.555 134.794c29.597-36.994 72.547-62.837 121.552-70.21l-23.201-40.185c-8.076-13.988-25.963-18.781-39.951-10.705l-70.91 40.94c-13.988 8.076-18.781 25.962-10.705 39.95z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.444 134.795 23.216-40.211c8.076-13.988 3.283-31.875-10.705-39.951l-70.91-40.94c-13.988-8.076-31.875-3.283-39.951 10.705l-23.201 40.186c49.005 7.374 91.954 33.217 121.551 70.211z",
    fill: "url(#SVGID_14_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m405 255c0 82.843-67.157 150-150 150-51.777 0-92.426-27.233-119.382-67.134-16.174-23.94-30.618-51.8-30.618-82.866 0-44.01 18.954-83.594 49.143-111.033 26.638-24.211 62.024-37.203 100.857-37.203 28.353 0 54.869 6.102 77.484 19.772 43.462 26.271 72.516 73.975 72.516 128.464z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.341 159.162c9.563-9.563 7.717-25.623-3.855-32.62-22.616-13.672-49.131-21.542-77.486-21.542-38.52 0-73.643 14.525-100.206 38.39-1.687 1.516-2.646 3.682-2.646 5.95 0 7.128 8.619 10.698 13.659 5.658 9.755-9.755 25.571-9.755 35.325 0 12.983 12.983 30.591 20.277 48.952 20.277h15.44c13.4 0 24.264 10.863 24.264 24.264v1.42c0 6.435-2.556 12.607-7.107 17.157-9.475 9.476-9.475 24.838 0 34.314 13.427 13.427 35.196 13.427 48.623 0l19.573-19.573c8.168-8.168 8.168-21.41 0-29.578l-14.537-14.537c-8.167-8.17-8.167-21.412.001-29.58z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.203 305.856c-13.469 0-20.214-16.284-10.69-25.808 6.7-6.7 6.7-17.563 0-24.263-6.7-6.7-17.563-6.7-24.263 0l-5.44 5.44c-5.401 5.401-14.158 5.401-19.559 0-7.297-7.297-11.396-17.193-11.396-27.512 0-11.078-8.98-20.058-20.058-20.058-9.782 0-18.183 7.048-19.779 16.699-1.253 7.573-1.938 15.337-2.011 23.248-.765 83.538 66.183 151.251 149.725 151.398 5.738.01 11.4-.303 16.97-.921 7.148-.793 10.243-9.453 5.158-14.539-3.336-3.336-3.336-8.745 0-12.081 10.917-10.917 10.917-28.617 0-39.534l-13.268-13.268c-12.038-12.038-28.365-18.801-45.389-18.801z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.02 268.654c-7.633 7.633-7.633 20.009 0 27.642l5.359 5.359c3.782 3.782 3.782 9.914 0 13.696-6.101 6.101-1.78 16.533 6.848 16.533 15.349 0 27.793-12.443 27.793-27.793 0-11.229-3.257-22.216-9.377-31.63l-.415-.638c-6.772-10.419-21.421-11.956-30.208-3.169z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.229 286.176c14.249 67.88 74.146 118.696 146.502 118.823 5.738.01 11.4-.303 16.97-.921 7.148-.793 10.243-9.453 5.158-14.539-3.336-3.336-3.336-8.745 0-12.081 10.917-10.917 10.917-28.617 0-39.534l-13.268-13.268c-12.038-12.038-28.364-18.8-45.388-18.8-10.86 0-17.342-10.586-14.455-19.68z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405 255c0 82.841-67.159 150-150 150-4.065 0-8.094-.159-12.076-.482-65.829-5.241-119.682-52.988-134.112-115.782-2.494-10.842-3.812-22.136-3.812-33.736 0-7.453.541-14.776 1.594-21.935h296.812c1.053 7.159 1.594 14.482 1.594 21.935z",
    fill: "url(#SVGID_20_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortalConnectionIcon);
export default __webpack_public_path__ + "static/media/portal-connection-icon.c99de7e926a38613fedf12ec3dd4fc3e.svg";
export { ForwardRef as ReactComponent };